import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Iconfont = styled.i`
  color: ${({ color }) => color};
  font-size: ${({ size }) => `${size}px`};
  &:hover {
    color: ${props => (props.hoverColor ? props.hoverColor : props.color)};
  }
`

const Icon = ({ type, size, color, ...others }) => (
  <Iconfont className={`iconfont icon-${type}`} size={size || '16px'} color={color} {...others} />
)

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  hoverColor: PropTypes.string,
}

Icon.defaultProps = {
  size: 16,
  color: '',
  hoverColor: '',
}

export default Icon
